import React from 'react';
import { generateId } from 'src/utils/IdGeneration';

export interface IHeadingProps extends React.AllHTMLAttributes<HTMLHeadingElement> {
  level: number;
}

// https://github.com/rexxars/react-markdown/blob/master/src/renderers.js#L67
export const HeadingRenderer: React.FC<IHeadingProps> = ({ level, children, ...props }) => {
  let queue = React.Children.toArray(children);
  const strings: string[] = [];
  while (queue.length) {
    const child = queue.shift();
    if (!child) continue;
    if (typeof child === 'string') {
      strings.push(child);
      continue;
    }
    if (React.isValidElement<{children?: React.ReactNode}>(child) && child.props.children) {
      queue = React.Children.toArray(child.props.children).concat(...queue);
    }
  }

  const id = generateId(strings);

  return React.createElement(
    `h${Math.max(Math.min(level, 6), 1)}`,
    { id, ...props },
    children
  );
};
